var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPrompterSuggestionGeneratorIcon = function SvgIconPrompterSuggestionGeneratorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__a)",
    d: "m7.713 2.226-.62 1.848a4.72 4.72 0 0 1-3.007 3.012l-1.868.621a.314.314 0 0 0 0 .599l1.868.62a4.7 4.7 0 0 1 2.984 2.989l.62 1.872a.315.315 0 0 0 .596 0l.644-1.848a4.72 4.72 0 0 1 2.984-2.989l1.867-.62a.314.314 0 0 0 0-.599l-1.844-.645A4.7 4.7 0 0 1 8.93 4.074l-.62-1.872a.315.315 0 0 0-.597.024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__b)",
    d: "m7.713 2.226-.62 1.848a4.72 4.72 0 0 1-3.007 3.012l-1.868.621a.314.314 0 0 0 0 .599l1.868.62a4.7 4.7 0 0 1 2.984 2.989l.62 1.872a.315.315 0 0 0 .596 0l.644-1.848a4.72 4.72 0 0 1 2.984-2.989l1.867-.62a.314.314 0 0 0 0-.599l-1.844-.645A4.7 4.7 0 0 1 8.93 4.074l-.62-1.872a.315.315 0 0 0-.597.024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__c)",
    fillRule: "evenodd",
    d: "M7.977 1.35a.965.965 0 0 1 .95.648l.621 1.875a4.06 4.06 0 0 0 2.591 2.596l.012.004 1.839.643a.963.963 0 0 1-.006 1.831l-1.864.62a4.07 4.07 0 0 0-2.573 2.577l-.003.009-.643 1.844v.002a.964.964 0 0 1-1.826-.002l-.002-.006-.62-1.872A4.06 4.06 0 0 0 3.88 9.543l-1.866-.62a.964.964 0 0 1 0-1.833l1.866-.62.002-.001a4.07 4.07 0 0 0 2.593-2.597l.001-.004.617-1.84a.97.97 0 0 1 .883-.677m5.606 7-.008-.003z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__d)",
    fillRule: "evenodd",
    d: "M7.977 1.35a.965.965 0 0 1 .95.648l.621 1.875a4.06 4.06 0 0 0 2.591 2.596l.012.004 1.839.643a.963.963 0 0 1-.006 1.831l-1.864.62a4.07 4.07 0 0 0-2.573 2.577l-.003.009-.643 1.844v.002a.964.964 0 0 1-1.826-.002l-.002-.006-.62-1.872A4.06 4.06 0 0 0 3.88 9.543l-1.866-.62a.964.964 0 0 1 0-1.833l1.866-.62.002-.001a4.07 4.07 0 0 0 2.593-2.597l.001-.004.617-1.84a.97.97 0 0 1 .883-.677m5.606 7-.008-.003z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__e)",
    d: "m12.428 2.057-.155.462a1.18 1.18 0 0 1-.752.753l-.467.155a.078.078 0 0 0 0 .15l.467.155a1.18 1.18 0 0 1 .746.747l.155.468a.078.078 0 0 0 .15 0l.16-.462a1.18 1.18 0 0 1 .746-.747l.467-.156a.078.078 0 0 0 0-.15l-.461-.16a1.18 1.18 0 0 1-.752-.753l-.155-.468a.079.079 0 0 0-.149.006"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__f)",
    d: "m12.428 2.057-.155.462a1.18 1.18 0 0 1-.752.753l-.467.155a.078.078 0 0 0 0 .15l.467.155a1.18 1.18 0 0 1 .746.747l.155.468a.078.078 0 0 0 .15 0l.16-.462a1.18 1.18 0 0 1 .746-.747l.467-.156a.078.078 0 0 0 0-.15l-.461-.16a1.18 1.18 0 0 1-.752-.753l-.155-.468a.079.079 0 0 0-.149.006"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__g)",
    fillRule: "evenodd",
    d: "M12.48 1.5a.58.58 0 0 1 .572.393l.156.47a.68.68 0 0 0 .432.434l.009.003.458.16a.578.578 0 0 1-.006 1.097l-.465.155a.68.68 0 0 0-.43.43l-.002.007-.16.462a.578.578 0 0 1-1.095-.003l-.001-.004-.155-.468a.68.68 0 0 0-.43-.43l-.465-.155a.578.578 0 0 1 0-1.099l.467-.155a.68.68 0 0 0 .433-.434l.001-.003.153-.458a.58.58 0 0 1 .529-.401m-.33 2.002a1.7 1.7 0 0 1 .352.355 1.7 1.7 0 0 1 .354-.353 1.7 1.7 0 0 1-.354-.354 1.7 1.7 0 0 1-.352.352",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_prompter_suggestion_generator_icon_svg__h)",
    fillRule: "evenodd",
    d: "M12.48 1.5a.58.58 0 0 1 .572.393l.156.47a.68.68 0 0 0 .432.434l.009.003.458.16a.578.578 0 0 1-.006 1.097l-.465.155a.68.68 0 0 0-.43.43l-.002.007-.16.462a.578.578 0 0 1-1.095-.003l-.001-.004-.155-.468a.68.68 0 0 0-.43-.43l-.465-.155a.578.578 0 0 1 0-1.099l.467-.155a.68.68 0 0 0 .433-.434l.001-.003.153-.458a.58.58 0 0 1 .529-.401m-.33 2.002a1.7 1.7 0 0 1 .352.355 1.7 1.7 0 0 1 .354-.353 1.7 1.7 0 0 1-.354-.354 1.7 1.7 0 0 1-.352.352",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__a",
    x1: 3,
    x2: 13,
    y1: 3,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__b",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__c",
    x1: 3,
    x2: 13,
    y1: 3,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__d",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__e",
    x1: 3,
    x2: 13,
    y1: 3,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__f",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__g",
    x1: 3,
    x2: 13,
    y1: 3,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#7490FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#235FDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4276EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_prompter_suggestion_generator_icon_svg__h",
    x1: 8,
    x2: 8,
    y1: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E82ED",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49C5E4",
    stopOpacity: 0.7
  })))));
};
export default SvgIconPrompterSuggestionGeneratorIcon;